// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"61c11cf0","235":"3b641641"}[chunkId] + ".chunk.css";
};